import type { GetInvoicesSummaryResponse } from '@vy/api-definition';
import { GetInvoicesSummaryResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetInvoicesSummary(options?: UseQueryOptions<GetInvoicesSummaryResponse>) {
  const { customerId } = useParams();

  return useQuery({
    queryKey: queryKeys.invoiceSummary(customerId),
    queryFn: async () => {
      const api = getPrivateApi();

      const getInvoicesSummaryResponse = await api.getInvoicesSummary({
        customerId,
      });

      return GetInvoicesSummaryResponseSchema.parse(getInvoicesSummaryResponse);
    },
    ...options,
  });
}
